<div class="text-center mt-5 pt-5">
    <h1><i class="far fa-circle-exclamation bad"></i></h1>

    <h1 class="pt-3">{{ 'view.error.oops' | translate }}</h1>

    <h3 class="pt-2 my-3">{{ error_msg | translate }}</h3>

    <p class="pt-2 my-3">{{ 'view.error.contact_us' | translate }} <a href="mailto:support@teammood.com">support&#64;teammood.com</a></p>

    @if(showCTA){
    <button class="btn btn-success my-4" routerLink="/home">{{ 'view.error.cta_label' | translate }}</button>
    }
</div>